<template>
    <div class="main-form">
        <StepNumber
            stepNum="5"
            totalSteps="5"
        ></StepNumber>
        <div class="main-form_info">
            <InputRadioButtons
                v-if="cliente_ya_inversor === false"
                :options = "$store.state.inputOptionsVariables.si_no"
                :title = "$store.state.newTexts.step_datos_financieros[0].title"
                :explanation = "$store.state.newTexts.step_datos_financieros[0].explanation || ''"
                :selected = "this.$store.state.prescoringData.cliente_inversor"
                @valueChanged = "(value) => handleValueChanged('cliente_inversor',value)"
            ></InputRadioButtons>
            <InputRadioButtons
                v-if="cliente_ya_inversor === false"
                :options = "$store.state.inputOptionsVariables.si_no"
                :title = "$store.state.newTexts.step_datos_financieros[5].title"
                :explanation = "$store.state.newTexts.step_datos_financieros[5].explanation || ''"
                :selected = "this.$store.state.prescoringData.cliente_my"
                @valueChanged = "(value) => handleValueChanged('cliente_my',value)"
            ></InputRadioButtons>
            <transition name="accordion" v-if="cliente_ya_inversor === false">
                    <InputRadioButtons
                        class="panel"
                        v-if="$store.state.prescoringData.cliente_my === true"
                        :options = "$store.state.inputOptionsVariables.si_no"
                        :title = "$store.state.newTexts.step_datos_financieros[4].title"
                        :explanation = "$store.state.newTexts.step_datos_financieros[4].explanation || ''"
                        :selected = "this.$store.state.prescoringData.cliente_hipoteca_my"
                        @valueChanged = "(value) => handleValueChanged('cliente_hipoteca_my',value)"
                    ></InputRadioButtons>
            </transition>
            <InputRadioButtons
                :options = "$store.state.inputOptionsVariables.si_no"
                :title = "$store.state.newTexts.step_datos_financieros[2].title"
                :explanation = "$store.state.newTexts.step_datos_financieros[2].explanation || ''"
                :selected = "this.$store.state.prescoringData.prestamo"
                @valueChanged = "(value) => handleValueChanged('prestamo',value)"
            ></InputRadioButtons>
            <Transition name="accordion">
                <InputSlider
                    class="panel"
                    v-if="$store.state.prescoringData.prestamo === true"
                    :minValue = 0
                    :maxValue = 10000
                    :step = 100
                    :initialValue = 0
                    :explanation="$store.state.newTexts.step_datos_financieros[3].explanation"
                    @valueChanged = "(value) => handleValueChanged('total_gastos',value)"
                ></InputSlider>
            </Transition>
        </div>

        <NavegationButtons 
            nextStep = "step_datos_personales"
            :nextStepButtonActive = "canContinue"
            nextStepButtonText = "Continuar"
            backStepButtonText = "Atrás"
        ></NavegationButtons>
    </div>
</template>

<script>
import StepNumber from '../common/StepNumber.vue'
import NavegationButtons from '../common/NavegationButtons.vue'
import InputRadioButtons from '../common/InputRadioButtons.vue'
import InputSlider from '../common/InputSlider.vue'

export default {
    name: 'step_datos_financieros',
    components: {
        StepNumber,
        NavegationButtons,
        InputRadioButtons,
        InputSlider
    },
    computed: {
        canContinue(){
            const {cliente_my, cliente_inversor, prestamo, total_gastos, cliente_hipoteca_my } = this.$store.state.prescoringData;
            
            if(this.cliente_ya_inversor){
                return prestamo !== null && ( prestamo === false || ( prestamo === true && (total_gastos > 0 && total_gastos !== null) ) );
            }

            return cliente_inversor !== null 
                && prestamo !== null 
                && cliente_my !== null
                && (cliente_my === false || ( cliente_my === true && cliente_hipoteca_my !== null))
                && ( prestamo === false || ( prestamo === true && (total_gastos > 0 && total_gastos !== null) ) );
        },
        cliente_ya_inversor(){
            return this.$store.state.prescoringData.utms.my_campaign == 'clientes-inversores';
        }
    },
    methods: {
        handleValueChanged(field, value){
            if(field === 'cliente_my' && value === false){
                this.$store.commit('updatePrescoringData', { field: 'cliente_hipoteca_my', value: null });
            }
            if(field === 'prestamo' && value === false){
                this.$store.commit('updatePrescoringData', { field: 'total_gastos', value: null });
            }
            this.$store.commit('updatePrescoringData', { field, value });
        }
    }
}
</script>

<style scoped>
    .title {
        font-size: 24px;
        font-weight: var(--font-weight-bold);
        margin: 0;
        line-height: 36px;
    }
    .button-financiero{
        background: transparent;
        border: 1px solid transparent;
        cursor: pointer;
        outline: none;
        padding: 0px;
        color: var(--primary);
        margin:0;
        font-size: var(--font-size-inputs);
        font-weight: var( --font-weight-bold) ;
    }
</style>